module.exports = "/assets/images/help.svg";